// some of the countryISO are not working properly, so we need to transform them to a locale that works
const transformIsoDateToLocale = (countryISO: string): string => {
  if (countryISO === 'US') {
    return 'en-US';
  }
  if (countryISO === 'JP') {
    return 'ja-JP';
  }
  if (countryISO === 'CN') {
    return 'zh-CN';
  }
  return countryISO;
};

/**
 * Formats a date to a string with a two-digit year, while keeping the locale-specific format for months and days.
 * Only shows hours and minutes, without seconds.
 *
 * @param {Date} date - The date to format.
 * @param {string} [locale=navigator.language] - The locale to use for formatting. Defaults to the browser's locale.
 * @returns {string} The formatted date string.
 */
export const formatDateTime = (date: Date, locale: string = navigator.language): string => {
  const localeToUse = transformIsoDateToLocale(locale);
  const options: Intl.DateTimeFormatOptions = {
    year: '2-digit',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };

  return new Intl.DateTimeFormat(localeToUse, options).format(date);
};

export const formatDate = (date: Date | string, showYear = true, locale: string = navigator.language): string => {
  const parsedDate = typeof date === 'string' ? new Date(date) : date;
  const localeToUse = transformIsoDateToLocale(locale);

  const options: Intl.DateTimeFormatOptions = {
    month: 'numeric',
    day: 'numeric',
    year: showYear ? 'numeric' : undefined,
  };

  return new Intl.DateTimeFormat(localeToUse, options).format(parsedDate);
};

export const formatTime = (date: Date | string, locale: string = navigator.language): string => {
  const parsedDate = typeof date === 'string' ? new Date(date) : date;
  const localeToUse = transformIsoDateToLocale(locale);

  const options: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
  };

  return new Intl.DateTimeFormat(localeToUse, options).format(parsedDate);
};
